module.exports = __webpack_public_path__ + "static/media/Augment.f6bda7df.png";